var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgNotebooklm = function SvgNotebooklm(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fillRule: "evenodd",
    strokeLinejoin: "round",
    strokeMiterlimit: 2,
    clipRule: "evenodd",
    viewBox: "0 0 512 512"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M255.979 66.987C114.603 66.987 0 183.21 0 326.657v124.33h47.19v-12.373c0-58.198 46.463-105.345 103.807-105.345s103.808 47.147 103.808 105.323v12.395h47.19v-12.373c0-84.63-67.627-153.174-150.998-153.174a148.64 148.64 0 0 0-87.168 28.117C89.6 261.59 142.656 225.92 203.947 225.92c86.55 0 156.736 71.21 156.736 158.998v66.069h47.19v-66.07c0-114.24-91.308-206.89-203.948-206.89a201.46 201.46 0 0 0-132.629 49.75c35.03-67.18 104.576-112.94 184.704-112.94 115.328 0 208.81 94.848 208.81 211.84v124.31H512v-124.33C511.98 183.21 397.376 66.986 255.98 66.986z"
  })));
};
export default SvgNotebooklm;